import './PeriscopeSummaryList.scss';
import { createSonarSelector } from '@lib/selectors';
import { PeriscopeSummary } from './PeriscopeSummary';
import React from 'react';
import { useSonarSelector } from '@hooks';
const periscopesSelector = createSonarSelector((state) => state.application.periscope.cards);
export const PeriscopeSummaryList = () => {
    const periscopes = useSonarSelector(periscopesSelector);
    return (React.createElement(React.Fragment, null, periscopes.map((periscope, index) => React.createElement(PeriscopeSummary, { index: index, key: periscope.id, periscope: periscope }))));
};
